import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import {
  IKpiLeaderboard,
  IKpiShift,
  IKpiSummary,
  IKpiTeam,
  IKpiWorkType,
  IKpiWorker,
  IKpiMonthlyFilter,
} from "@/features/kpi/kpi.types";
import { cleanParams } from "@/utils/cleanParams";

export const kpiService = {
  getSummary(): Promise<AxiosResponse> {
    return http.get<IKpiSummary>("/kpi/summary");
  },

  getWorkers(): Promise<AxiosResponse> {
    return http.get<IKpiWorker[]>("/kpi/workers");
  },

  getShifts(): Promise<AxiosResponse> {
    return http.get<IKpiShift[]>("/kpi/shifts");
  },

  getWorkTypes(): Promise<AxiosResponse> {
    return http.get<IKpiWorkType[]>("/kpi/work-types");
  },

  getTeams(): Promise<AxiosResponse> {
    return http.get<IKpiTeam[]>("/kpi/teams");
  },

  getLeaderboard(): Promise<AxiosResponse> {
    return http.get<IKpiLeaderboard[]>("/kpi/leaderboard");
  },

  getMonthlyStatistics(filter: IKpiMonthlyFilter): Promise<AxiosResponse> {
    return http.get("/kpi/user-monthly-statistics", {
      params: cleanParams(filter),
    });
  },
};
